export { default } from "bullitttime-embermodelsevent/adapters/team-result";
